import { newEl, child, upTo, setClass } from "./dom.js";
import Grid from "./grid.js";

export default class InteractiveGrid extends Grid {
	constructor(...args) {
		super(...args);
		this.el.addEventListener("click", this.clickHandler(false));
		this.el.addEventListener("contextmenu", this.clickHandler(true));
	}

	clickHandler(direction) {
		return e => {
			e.preventDefault();
			const td = upTo(e.target, e => e.dataset.x);
			if (!td) {
				console.log("Unexpected element click", e.target);
				return;
			}
			// OK so: wall locations are centred around the 'off' corners, the ones without dots in, so we need to work out which we're nearest.
			const { x, y, xyParity } = this.cells[td.dataset.y][td.dataset.x];

			// TODO: REMOVE THIS HACK THAT REPLACES THE CLICK ACTION WITH HIGHLIGHT
			// for (const r of this.ribbons) r.highlightBy(x, y); return;

			// if the user clicked a button, we don't care where on the button they clicked —
			// buttons are centred on the particular intersection they're in so just use that
			if (e.target.tagName === "BUTTON") {
				this.toggleWall(x, y, direction);
				return;
			}

			const rect = td.getBoundingClientRect();
			const mouseX = (event.clientX - rect.left) / rect.width;
			const mouseY = (event.clientY - rect.top) / rect.height;
			if (xyParity && mouseX > mouseY) this.toggleWall(x + 1, y, direction);
			if (xyParity && mouseX <= mouseY) this.toggleWall(x, y + 1, direction);
			if (!xyParity && mouseX <= 1 - mouseY) this.toggleWall(x, y, direction);
			if (!xyParity && mouseX > 1 - mouseY) this.toggleWall(x + 1, y + 1, direction);
		};
	}
}